import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { promoOptimization } from 'gqlQueries/promoRecommendation';
import { sendNotification } from 'utils/helperMethods';

const errorMessage: string = 'Something went wrong!';

function useOptimismPromo({ onComplete }: { onComplete: Function }) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);

    const [optimizePlan] = useMutation(promoOptimization, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const data = payload?.data || payload;
            if (data?.promoOptimization) {
                const { error } = data.promoOptimization;
                if (error) onFetchError(error || errorMessage);
            }
            onComplete(data);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        sendNotification('error', 'Something went wrong with promo optimization');
        setLoading(false);
        setError(String(error));
    }

    return {
        loading,
        error,
        setError,
        optimizePlan: (variables: any) => {
            setError(null);
            setLoading(true);
            return new Promise((resolve, reject) => {
                optimizePlan(variables)
                    .then((response: any) => {
                        resolve(response);
                        setLoading(false);
                    })
                    .catch((error: any) => {
                        reject(error);
                        setLoading(false);
                    });
            });
        },
    };
}

export default useOptimismPromo;
